"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var api_service_1 = require("./api-service");
var TaxService = /** @class */ (function (_super) {
    __extends(TaxService, _super);
    function TaxService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.endpoint = 'taxes';
        return _this;
    }
    TaxService.prototype.taxRates = function (params) {
        return this.getCollectionRequest(this.url('rates'), {
            params: params,
        });
    };
    TaxService.prototype.createTaxRate = function (taxRate) {
        return this.postRequest(this.url('rates'), taxRate);
    };
    TaxService.prototype.getTaxRate = function (id) {
        return this.getRequest(this.url('rates', id));
    };
    TaxService.prototype.updateTaxRate = function (id, taxRate) {
        return this.putRequest(this.url('rates', id), taxRate);
    };
    TaxService.prototype.deleteTaxRate = function (id) {
        return this.deleteRequest(this.url('rates', id));
    };
    TaxService.prototype.vatRates = function (params) {
        return this.getCollectionRequest(this.url('vat'), {
            params: params,
        });
    };
    TaxService.prototype.createVatRate = function (taxRate) {
        return this.postRequest(this.url('vat'), taxRate);
    };
    TaxService.prototype.getVatRate = function (id) {
        return this.getRequest(this.url('vat', id));
    };
    TaxService.prototype.updateVatRate = function (id, taxRate) {
        return this.putRequest(this.url('vat', id), taxRate);
    };
    TaxService.prototype.deleteVatRate = function (id) {
        return this.deleteRequest(this.url('vat', id));
    };
    //Groups
    TaxService.prototype.taxRateGroups = function (params) {
        return this.getCollectionRequest(this.url('groups'), {
            params: params,
        });
    };
    TaxService.prototype.createTaxRateGroup = function (taxRate) {
        return this.postRequest(this.url('groups'), taxRate);
    };
    TaxService.prototype.getTaxRateGroup = function (id) {
        return this.getRequest(this.url('groups', id));
    };
    TaxService.prototype.updateTaxRateGroup = function (id, taxRate) {
        return this.putRequest(this.url('groups', id), taxRate);
    };
    TaxService.prototype.deleteTaxRateGroup = function (id) {
        return this.deleteRequest(this.url('groups', id));
    };
    TaxService.prototype.testAvalaraConnection = function () {
        return this.getRequest(this.url('avalara', 'test'));
    };
    return TaxService;
}(api_service_1.ApiService));
exports.default = TaxService;
//# sourceMappingURL=tax-service.js.map